import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LedgerAccountSchema = withDefaults({
  type: 'ledger-account',
  fields: [
    {
      kind: 'attribute',
      name: 'name',
    },
    {
      kind: 'attribute',
      name: 'accountType',
    },
    {
      kind: 'attribute',
      name: 'accountSubtype',
    },
    {
      kind: 'attribute',
      name: 'product',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'attribute',
      name: 'balance',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default LedgerAccountSchema;
